/**
 * Docurain関連の定数ファイル
 */

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace FormSetting {
    export const previewName = 'preview';
    export const inputNames = {
    type: 'form_type',
    format: 'output_format',
    templateName: 'docurain_template_name',
    formName: 'form_name'
    }
    export const initialSearchCondition = [ 'use_scene', 'valid_invalid' ];
}
export const previewName = FormSetting.previewName;
export const inputNames = FormSetting.inputNames;
export const initialSearchCondition = FormSetting.initialSearchCondition;

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace DocurainSetting {
    export const contentType: {[k:string]: string} = {
        pdf: 'application/pdf',
        xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }
    export const mapFormat: {[k:string]: string} = {
        pdf: 'pdf',
        excel: 'xlsx',
        png: 'png'
    }
}
export const contentType = DocurainSetting.contentType;
export const mapFormat = DocurainSetting.mapFormat;
export const KeiyakushoDataReportIdOA = 'r_contract_template_OA';
export const KeiyakushoDataReportIdGeneral = 'r_contract_template_General';
